<template>
    <div class="main">
        <div class="main-title">
            <span class="cancel" @click="goBack">取消</span>
            <span>添加图片描述</span>
            <span class="sort-btn" @click="goSort">排序</span>
        </div>
        <div class="desc-container">
            <div class="desc-item" v-for="(item, index) in imgList" :key="index">
                <div class="item-top">
                    <img class="item-img" :src="item.url">
                    <a class="del-btn" href="javascript:;" @click="deleteImgItem(index)">删除</a>
                </div>
                <div class="item-detail">
                    <textarea class="desc-content" placeholder="请输入图片描述(200字以内)..." v-model="item.desc" @input="textMax(item.desc, index)"></textarea>
                </div>
            </div>
        </div>
        <div class="add-img">
            <el-upload
                class="add-groupImgs"
                :action="eatlasUploadUrl"
                :before-upload="handleBefore"
                :on-success="handleSuccess"
                :on-error="handleError"
                multiple
                :show-file-list='false'
                :file-list="fileList">
                <label class="btn-image"><span class="file-icon"></span>添加图片</label>
            </el-upload>
        </div>
        <div class="to-next" @click="goPageatlas">
            <a class="next-btn" href="javascript:;">下一步</a>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                imgList: [],
                fileList: [],
                eatlasUploadUrl: '',
                formData: {},
            }
        },
        mounted(){
            this.eatlasUploadUrl = "http://"+window.location.host+'/picUpload';
            if(this.$route.query.imgList && typeof(this.$route.query.imgList[0])=='object' && this.$route.query.imgList[0].url){
                this.imgList = this.$route.query.imgList;
            }
            if(this.$route.query.formData){
                this.formData = this.$route.query.formData;
            }
            // console.log(this.$route.query);
        },
        components: {

        },
        methods: {
            goBack (){
                this.$router.go(-1);
            },
            goPageatlas (){
                if(this.imgList.length <= 0){
                    this.$layer.toast({
                        className: 'loadImg', // 图标clssName 如果为空 toast位置位于下方,否则居中 
                        content: '请添加图片',
                        time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒 
                    })
                    return; 
                }
                this.$router.push({path: '/Pageatlas', query:{imgList: this.imgList, formData: this.formData}});
            },
            goSort (){
                if(this.imgList.length <= 0){
                    this.$layer.toast({
                        className: 'loadImg', // 图标clssName 如果为空 toast位置位于下方,否则居中 
                        content: '请添加图片',
                        time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒 
                    })
                    return; 
                }
                this.$router.push({path: '/ImgListSort', query:{imgList: this.imgList, formData: this.formData}});
            },
            handleBefore (file) {
                console.log(file);
            },
            handleSuccess (response, file, fileList) {
                let fileData = {
                    name: file.name,
                    desc: '',
                    url: response.urls[0].src
                }
                this.imgList.push(fileData)
            },
            handleError (err, file, fileList) {
                this.$layer.dialog({
                    content: '上传失败，请重新尝试',
                    time: 2000
                })
            },
            deleteImgItem (index){
                this.imgList.splice(index, 1);
            },
            textMax (text, index){
                if(text.trim().length > 200){
                    this.imgList[index].desc = this.imgList[index].desc.slice(0, 200);
                    this.$layer.dialog({
                        content: '图片描述仅限200字以内',
                        time: 2000
                    })
                }
            },
        }
    }
</script>
<style scoped>
    textarea::-webkit-input-placeholder {
        color: #999;
    }
    .main-title {
        background: #fc4a44;
        line-height: 0.9rem;
        font-size: 0.34rem;
        color: #fff;
        text-align: center;
        border-bottom: 1px solid #eee;
    }
    .cancel{
        float: left;
        display: inline-block;
        margin-left: 0.25rem;
    }
    .sort-btn{
        float: right;
        display: inline-block;
        margin-right: 0.25rem;
    }
    .desc-container{
        background: #e1e1e1;
        padding-bottom: 0.01rem;
    }
    .desc-container .desc-item{
        padding: 0.2rem;
        margin-bottom: 0.15rem;
        background: #fff;
    }
    .desc-item .item-top{
        border-bottom: 1px solid #e1e1e1;
        padding-bottom: 0.2rem;
    }
    .desc-item .item-img{
        width: 1.8rem;
        height: 1.4rem;
    }
    .desc-item .del-btn{
        font-size: 0.28rem;
        float: right;
        width: 1.1rem;
        text-align: center;
        border: 1px solid #ddd;
        padding:  0.05rem 0;
        border-radius: 0.05rem;
        margin-top: 0.4rem;
    }
    .desc-item .item-detail{
        padding-top: 0.2rem;
        overflow: hidden;
    }
    .desc-item .desc-content{
        width: 100%;
        font-size: 0.28rem;
        height: 1.4rem;
        border: 0;
        padding: 0 0.15rem;
    }
    .desc-item .tips{
        float: left;
        font-size: 0.26rem;
        display: inline-block;
        width: 100%;
        background: #aaa;
        color: #B71721;
        padding: 0.02rem;
    }
    .add-img{
        position: relative;
        width: 100%;
        height: 0.72rem;
        overflow: hidden;
        margin-bottom: 1.2rem;
        margin-top: 0.2rem;
    }
    /* .add-img .file-icon{
        padding: 0.1rem 0.26rem;
        background: url('./../../assets/img/camera.png') no-repeat center center;
        background-size: 0.5rem;
        margin-right: 0.1rem;
    } */
    .btn-image{
        display: inline-block;
        position: absolute;
        top: 0;
        left: 50%;
        padding: 0;
        padding-left: 0.60rem;
        line-height: 0.65rem;
        width: 2.52rem;
        height: 0.67rem;
        border: 1px solid #ddd;
        border-radius: 0.05rem;
        font-size: 0.32rem;
        margin-left: -1.15rem;
        color: #666;
        background: url('./../../assets/img/camera.png') no-repeat 0.3rem 0.07rem;
        background-size: 0.5rem;
    }
    .to-next{
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #fc4a44;
        text-align: center;
    }
    .to-next .next-btn{   
        color: #fff;
        font-size: 0.36rem;
        line-height: 0.8rem;
    }
</style>




// WEBPACK FOOTER //
// src/components/pageatlas/editImgList.vue